import { GridColDef } from '@mui/x-data-grid'

import { isNotEmpty } from '@helpers'
import { FIELD_VALUE_TYPE } from '@constants'
import { ObjectDataRecord } from '@types'

// Расширенный тип для колонок с дополнительными свойствами
type ExtendedGridColDef = GridColDef<ObjectDataRecord> & {
  valueType?: string
  valueFormat?: string
}

export const checkIsResponseValueMatch = (
  responseValue: any,
  payloadValue: any,
  field: string,
  columns: ExtendedGridColDef[]
): boolean => {
  const cellField = columns.find(col => col.field === field)
  const isBooleanType = cellField?.valueType === FIELD_VALUE_TYPE.BOOLEAN && !cellField?.valueFormat
  const isPositionRef = cellField?.value === 'position_ref'

  if (isBooleanType) {
    return (
      (responseValue === true && payloadValue === 'true') ||
      (responseValue === false && payloadValue === 'false')
    )
  }
  // В связи с логикой бэка используется хардкодное значение поля
  // При обнудлении position_ref возвращает '*' а не null
  // https://jiradc.utg.group/browse/WF-5859 см. комментарии
  if (isPositionRef) {
    const isEmptyPayload =
      payloadValue === '' || payloadValue === null || payloadValue === undefined
    const isEmptyResponse = responseValue === '*'

    if (isEmptyPayload && isEmptyResponse) {
      return true
    }
  }

  if (!isNotEmpty(responseValue) && !isNotEmpty(payloadValue)) {
    return true
  }

  const normalizedResponse = Array.isArray(responseValue)
    ? JSON.stringify(responseValue)
    : responseValue

  const normalizedPayload = Array.isArray(payloadValue)
    ? JSON.stringify(payloadValue)
    : payloadValue

  return normalizedResponse === normalizedPayload
}
